m = require 'mithril'

class RoundViewModel
	constructor: (players, round) ->
		@players = m.prop players
		@playerHands = {}
		@playerHands[player.id] = new HandViewModel round[player.id] for player in players

	buildRound: () ->
		round = {}

		for playerId, hand of @playerHands
			round[playerId] = {
				status: hand.status()
				redThrees: parseInt hand.redThrees()
				mixedCanastas: parseInt hand.mixedCanastas()
				naturalCanastas: parseInt hand.naturalCanastas()
				pointsInMelds: parseInt hand.pointsInMelds()
				pointsInHand: parseInt hand.pointsInHand()
			}
		
		round		

class HandViewModel
	constructor: (hand = {}) ->
		@status = m.prop hand.status ? null
		@redThrees = m.prop hand.redThrees ? 0
		@mixedCanastas = m.prop hand.mixedCanastas ? 0
		@naturalCanastas = m.prop hand.naturalCanastas ? 0
		@pointsInMelds = m.prop hand.pointsInMelds ? 0
		@pointsInHand = m.prop hand.pointsInHand ? 0

module.exports = RoundViewModel